/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzssprachen11Inputs */

const en__field_enum_mzssprachen11 = /** @type {(inputs: _Field_Enum_Mzssprachen11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`linguistics and cultural studies`)
};

const de__field_enum_mzssprachen11 = /** @type {(inputs: _Field_Enum_Mzssprachen11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprach- und Kulturwissenschaft`)
};

/**
* | output |
* | --- |
* | "linguistics and cultural studies" |
*
* @param {_Field_Enum_Mzssprachen11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzssprachen11 = /** @type {((inputs?: _Field_Enum_Mzssprachen11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzssprachen11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzssprachen11(inputs)
	return de__field_enum_mzssprachen11(inputs)
});
export { _field_enum_mzssprachen11 as "_field_enum_MZSSPRACHEN" }